import CompleteInfo from '../screen/container/acount/complete-create-account-isv/complete-info/complete-info';
import CompleteAdresse from '../screen/container/acount/complete-create-account-isv/complete-adresse/complete-adresse';
import CompleteInterested from '../screen/container/acount/complete-create-account-isv/complete-interested/complete-interested';
import CompleteProfilicture from '../screen/container/acount/complete-create-account-isv/complete-profil-picture/complete-profil-picture';
import CompleteAccount from '../screen/container/acount/complete-create-account-isv/complete-account/complete-account';
import ActivateEmail from '../screen/container/acount/complete-create-account-isv/activate-email/activate-email';
// import DashboardPage from "../screen/container/dashboard/commun_dashboard/dashboard";
import MatchIsv from '../screen/container/find-isv-matching/matching-result';
//import MatchIsvTemplate from "../screen/container/isv/find-isv/TEMPLATE_INTEGRE";
import UnlockedIsvOEM from '../screen/container/find-isv-matching/unlocked-isv';
import FindMoreIsv from '../screen/container/find-isv-matching/find-more';
import Favorite from '../screen/container/find-isv-matching/favorite-page';
import NotFound from '../screen/container/not-found/not-found';

export const routesIsv = [
  {
    path: '/complete-info',
    guard: 'not-logged-page',
    exact: true,
    component: CompleteInfo,
  },
  {
    path: '/complete-adresse',
    guard: 'not-logged-page',
    exact: true,
    component: CompleteAdresse,
  },
  {
    path: '/complete-interested',
    guard: 'not-logged-page',

    exact: true,
    component: CompleteInterested,
  },
  {
    path: '/complete-profil-picture',
    guard: 'not-logged-page',
    exact: true,
    component: CompleteProfilicture,
  },
  {
    path: '/complete-account',
    guard: 'public',
    exact: true,
    component: CompleteAccount,
  },
  {
    path: '/activate_account',
    guard: 'not-logged-page',
    exact: true,
    component: ActivateEmail,
  },

  {
    path: '/isv/match',
    guard: 'public',
    exact: true,
    component: MatchIsv,
  },

  {
    path: '/isv/favorite-page',
    guard: 'public',
    exact: true,
    component: NotFound, // Favorite,
  },
  {
    path: '/isv/find-more',
    guard: 'public',
    exact: true,
    component: NotFound, //FindMoreIsv,
  },
  {
    path: '/isv/isv-unlocked',
    guard: 'public',
    exact: true,
    component: NotFound, //UnlockedIsvOEM,
  },
];
